/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { registerRequestSchema } from "./registerRequestSchema.ts";
import { tokensSchema } from "./tokensSchema.ts";

export const userRegisterCreateStatus200Schema = tokensSchema.describe("Сериализатор вывода токена - для документации.");

export const userRegisterCreateStatus400Schema = errorResponseSchema;

export const userRegisterCreateResponseSchema = z.union([userRegisterCreateStatus200Schema, userRegisterCreateStatus400Schema]);

export const userRegisterCreateDataSchemaJson = registerRequestSchema.describe("Сериализатор регистрации пользователя.");

export const userRegisterCreateDataSchemaXml = registerRequestSchema.describe("Сериализатор регистрации пользователя.");

export const userRegisterCreateDataSchema = z.union([userRegisterCreateDataSchemaJson, userRegisterCreateDataSchemaXml]);
